// extracted by mini-css-extract-plugin
module.exports = {"container":"Header-module--container--1n00k","headerText":"Header-module--header-text--2ZrXu gradient-text"};